import ReactPlayer from "react-player"

type VaasVideoPlayerProps = {
  poster?: string | null
  url?: string | null
}

const VaasVideoPlayer = ({ poster, url }: VaasVideoPlayerProps) => {
  return (
    <div
      className="relative overflow-hidden rounded-md bg-black"
      style={{ paddingTop: "56.25%" }}
    >
      <ReactPlayer
        controls
        url={url || undefined}
        config={{
          file: {
            attributes: {
              poster,
              preload: "auto",
            },
          },
        }}
        height="100%"
        style={{ left: 0, position: "absolute", top: 0 }}
        width="100%"
      />
    </div>
  )
}

export default VaasVideoPlayer
